import React, { useState } from 'react';
import useReviewActions from '../hooks/AdminReviewsPage/useReviewActions';
import ReviewsTable from '../components/AdminReviewsPage/ReviewsTable';
import ReviewsBulkActions from '../components/AdminReviewsPage/ReviewsBulkActions';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import ReviewEditModal from '../components/AdminReviewsPage/ReviewEditModal';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';
import '../styles/AdminBulkActions.css';

const AdminReviewsPage = () => {
  const [editReview, setEditReview] = useState(null);

  const {
    reviews,
    selectedReviews,
    searchTerm,
    isLoading,
    boats,
    handleSearch,
    handleSelectAll,
    handleReviewSelect,
    handleBulkApprove,
    handleBulkReject,
    handleBulkDelete,
    handleApproveReview,
    handleRejectReview,
    handleDeleteReview,
    loadReviews,
    clearSelectedReviews
  } = useReviewActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Reviews</h1>
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleSearch} />
          <ReviewsBulkActions
            selectedReviews={selectedReviews}
            onApprove={handleBulkApprove}
            onReject={handleBulkReject}
            onDelete={handleBulkDelete}
            clearSelectedReviews={clearSelectedReviews}
            loadReviews={loadReviews}
          />
        </div>

        {isLoading ? (
          <AdminTableLoadingSpinner />
        ) : (
          <>
            <ReviewsTable
              reviews={reviews}
              selectedReviews={selectedReviews}
              onReviewSelect={handleReviewSelect}
              onSelectAll={handleSelectAll}
              onApproveReview={handleApproveReview}
              onRejectReview={handleRejectReview}
              onDeleteReview={handleDeleteReview}
              onEdit={setEditReview}
            />
            <div className="admin-page__footer">
              <p>Reviews count: {reviews.length}</p>
            </div>
          </>
        )}
      </div>

      <ReviewEditModal
        isOpen={!!editReview}
        onClose={() => setEditReview(null)}
        onSuccess={() => {
          loadReviews();
          setEditReview(null);
        }}
        review={editReview}
        boats={boats}
      />
    </div>
  );
};

export default AdminReviewsPage; 